import { FC, useEffect, useState } from 'react';
import classes from './FileThumbnail.module.scss';
import { Props } from './types';
import { toBase64 } from '../../services/http';


export const FileThumbnail: FC<Props> = ({ files, error }) => {
  const [stringFiles, setStringFiles] = useState<string[]>([]);

  useEffect(() => {
    toBase64(files[0])
      .then((input) => setStringFiles([input]));
  }, [files]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.thumbnailWrapper}>
        {files[0].type === 'application/pdf' ? (
          <embed
            src={stringFiles[0]}
            type="application/pdf"
            height="100%"
            width="100%"
          />
        ) : (
          <img src={stringFiles[0]} className={classes.image} alt=""/>
        )}
      </div>

      <div className={classes.text}>
        <div className={classes.line} title={files[0].name}>{files[0].name}</div>
        <div className={classes.line}>{Math.round(files[0].size * 100 / 1024 / 1024) / 100} MB</div>
        {error && (<div className={classes.error}>{error}</div>)}
      </div>
    </div>
  );
};
